import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';

const FinancialWellnessWorkshopNov2025 = () => {
    const workshopImages = [
        "1000377130.jpg",
         "1000377141.jpg",
         "1000377148.jpg",
         "1000377164.jpg",
    ];

    return (
        <div>
            <Navbar />

            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2>
                                        One Day Workshop on Financial Wellness for MBA Students
                                    </h2>

                                    <div className="py-2">
                                        <p>
                                            A one-day workshop on <strong>Financial Wellness</strong> was conducted
                                            for MBA students under the Smart Investors Awareness Program.
                                            The session was organized by the <strong>Bombay Stock Exchange (BSE)</strong>
                                            to enhance students' understanding of financial planning, investments,
                                            and smart money management.
                                        </p>

                                        <p>
                                            The workshop was led by <strong>Mr. Rishabh Lunia</strong> on
                                            <strong> 21st November 2025</strong>, engaging both first-year and
                                            final-year MBA students. The session focused on building financial
                                            literacy, understanding stock markets, and encouraging informed
                                            investment decisions among young professionals.
                                        </p>
                                    </div>

                                    <div className="css-script-ads"></div>

                                    <div className="spotlight-group">
                                        <div className="row">
                                            {workshopImages.map((img, index) => (
                                                <div key={index} className="col-md-6 mb-3 mb-lg-4">
                                                    <a
                                                        className="spotlight"
                                                        href={`https://admin.swec.ac.in/assetsswec/img/Financial-Wellness-Workshop-Nov-2025/${img}`}
                                                    >
                                                        <img
                                                            src={`https://admin.swec.ac.in/assetsswec/img/Financial-Wellness-Workshop-Nov-2025/${img}`}
                                                            alt={`Financial Wellness Workshop Image ${index + 1}`}
                                                            className="img-responsive center-block rounded-1"
                                                        />
                                                    </a>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default FinancialWellnessWorkshopNov2025;
